import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../context/authContext";
import { FetchContext } from "../context/FetchContext";
import { Row, Col, Button, Card, Alert, Modal } from "react-bootstrap";
import { Navigate, useNavigate } from "react-router-dom";
export default function ProjectCard({ props }) {
    const { authState } = useContext(AuthContext);
    const history = useNavigate();
    useEffect(() => {}, [props]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    function AlertDismissible({ props }) {
        return (
            <>
                <Modal
                    show={show}
                    onHide={handleClose}
                    backdrop="static"
                    variant="light"
                >
                    <Alert
                        show={show}
                        variant="light"
                        onClose={() => setShow(false)}
                        dismissible
                        style={{ marginBottom: "0px" }}
                    >
                        <Alert.Heading>Confirm Project Selection</Alert.Heading>
                        <p>
                            You selected {props.fieldData.ProjectName}
                            <br />
                            If this was a mistake, click the "X".
                        </p>

                        <div className="d-flex justify-content-end">
                            <Button
                                onClick={() => goToProject(props)}
                                variant="primary"
                                className="mobbtn"
                            >
                                Go To Project
                            </Button>
                        </div>
                    </Alert>
                </Modal>
                {!show && (
                    <Button
                        className="mobbtn"
                        onClick={() => setShow(true)}
                        variant="danger"
                    >
                        Go To Project
                    </Button>
                )}
            </>
        );
    }

    function goToProject(project) {
        const lineItems = [
            {
                quantity: '1',
                ProductType: '',
                ProductDetail: '',
                rate: '0.00',
                unit: '',
                amount: '',
            },
        ];

        // Check if project.portalData["Projects | ConsultantsAssign"] exists
        let consul = project.portalData["Projects | ConsultantsAssign"]
        
        // console.log("Consultants data:", consul);
        if (!authState.userInfo?.zd_pk_Consultants) {
            // console.log(authState);
            console.error("User consultant ID is missing in authState");
            return;
        }

        if (!consul || Object.keys(consul).length === 0) {
            console.error("Consultants data is empty or undefined");
            return;
        }

        // console.log("Consultants data:", consul);
        // console.log("Current user consultant ID:", authState.userInfo.zd_pk_Consultants);

        // Filter consultant data
        const rt = Object.values(consul).filter(
            (value) =>
                value["Projects | ConsultantsAssign::zd_fk_Consultant"] ===
                authState.userInfo.zd_pk_Consultants
        );

        // console.log("Filtered consultant data:", rt);

        // Check if rt has valid data
        if (rt.length === 0) {
            console.error("No matching consultant data found");
            alert("No matching consultant data found for this project.");
            return;
        }

        // Build rateInfo object
        // console.log(rt)
        const rateInfo = {
            billRate: rt[0]?.["Projects | ConsultantsAssign::BillRate"] || "N/A",
            billType: rt[0]?.["Projects | ConsultantsAssign::BillType"] || "N/A",
            billRate2: rt[1]?.["Projects | ConsultantsAssign::BillRate"] || "N/A",
            billType2: rt[1]?.["Projects | ConsultantsAssign::BillType"] || "N/A",
            fullName: rt[0]?.["Projects | ConsultantsAssign::FullName"] || "N/A",
            username: rt[0]?.["Projects | ConsultantsAssign::Username"] || "N/A",
            userID: rt[0]?.["Projects | ConsultantsAssign::zd_fk_Consultant"] || "N/A",
        };
// console.log("Rate Info:", rateInfo);
        // Build project object
        const proj = {
            ...project.fieldData,
            lineItems,
        };

        const proj2 = {
            ...proj,
            rateInfo,
        };

        const proj3 = {
            ...proj2,
            locations: [], // Default empty locations
        };

        // Save to local storage
        localStorage.setItem("proj3", JSON.stringify(proj3));

        // Navigate to the project page
        history("/project");
    }

    return (
        <>
            <Row className="justify-content-center my-2">
                <Card style={{ width: '35rem' }}>
                    <Card.Body>
                        <Card.Title>{props.fieldData.ProjectName}</Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">
                            {props.fieldData.Company_Name}
                        </Card.Subtitle>
                        <Card.Text className="mb-1">
                            {props.fieldData.Address}
                        </Card.Text>
                        <br />
                        <Card.Text className="mb-1">
                            {props.fieldData.City +
                                " " +
                                props.fieldData.State +
                                ", " +
                                props.fieldData.Zip}
                        </Card.Text>
                        <br />
                        <Card.Text>{props.fieldData.Email}</Card.Text>
                        <br />
                        <AlertDismissible props={props} />
                    </Card.Body>
                </Card>
            </Row>
        </>
    );
}